import React from "react";
import Helmet from "react-helmet";
import { useIntl } from "react-intl";

export default function Seo(){
    const intl = useIntl();
    const t = intl.formatMessage;

    return(
        <Helmet>
        <html lang={t({ id: "page.lang" })} prefix="og: http://ogp.me/ns#" />
        <title>{t({ id: "ductlessHeatPumpPage.title" })}</title>
        <meta name="title" content={t({ id: "ductlessHeatPumpPage.title" })} />
        <meta name="description" content={t({ id: "ductlessHeatPumpPage.meta-description" })} />
        <meta name="keywords" content={t({ id: "ductlessHeatPumpPage.meta-keywords" })} />
        <meta name="robots" content={t({ id: "ductlessHeatPumpPage.meta-robots" })} />

        <link rel="canonical" href={t({ id: "ductlessHeatPumpPage.canonical" })} />
        {/* <link rel="alternate" href={t({ id: "ductlessHeatPumpPage.alternateHrefLangEn" })} hreflang="en-CA" /> */}
        {/* <link rel="alternate" href={t({ id: "ductlessHeatPumpPage.alternateHrefLangFr" })} hreflang="fr-Ca" /> */}

        <meta property="og:title" content={t({ id: "ductlessHeatPumpPage.title" })} />
        <meta property="og:description" content={t({ id: "ductlessHeatPumpPage.meta-description" })} />
        {/* <meta property="og:image" content={LGPrestigeImage} /> */}
        <meta property="og:site_name" content="Andmar eco-Energy" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content={t({ id: "ductlessHeatPumpPage.ogLocale" })} />
        <meta property="og:url" content={t({ id: "ductlessHeatPumpPage.canonical" })} />

        <meta name="twitter:title" content={t({ id: "ductlessHeatPumpPage.title" })} />
        <meta name="twitter:description" content={t({ id: "ductlessHeatPumpPage.meta-description" })} />
        {/* <meta name="twitter:image" content={LGPrestigeImage} /> */}
        <meta name="twitter:site" content="@Andmarecoenergy" />
        <meta name="twitter:card" content="summary_large_image" />

    </Helmet>
    )
}